var _mask, _g, _mask2, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "iyambo3o9a",
    width: 200,
    height: 200,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100 200c55.228 0 100-44.772 100-100S155.228 0 100 0 0 44.772 0 100s44.772 100 100 100z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#iyambo3o9a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100 200c55.228 0 100-44.772 100-100S155.228 0 100 0 0 44.772 0 100s44.772 100 100 100z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "thyndslknb",
    width: 200,
    height: 200,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100 200c55.228 0 100-44.772 100-100S155.228 0 100 0 0 44.772 0 100s44.772 100 100 100z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#thyndslknb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M100 200c55.228 0 100-44.772 100-100S155.228 0 100 0 0 44.772 0 100s44.772 100 100 100z",
    opacity: 0.523
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAA51A",
    fillRule: "evenodd",
    d: "M96.41 64.668c2.098-2.047 5.467-1.997 7.526.111l-3.799 3.715-3.727-3.826zm-7.463-7.625c3.023-2.958 7.105-4.586 11.346-4.525 4.24.061 8.291 1.806 11.259 4.85l-3.799 3.714c-4.122-4.22-10.868-4.32-15.07-.223l-3.736-3.816zM81.484 49.4c10.492-10.242 27.346-10 37.648.538l-3.799 3.715c-3.954-4.053-9.35-6.377-14.998-6.46-5.65-.081-11.087 2.086-15.115 6.023L81.484 49.4zm-7.264-7.423l.193-.206c14.609-14.267 38.056-14.025 52.518.54l-3.799 3.715c-12.399-12.463-32.477-12.663-44.993-.447l-.192.206-3.727-3.808z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFCF8",
    d: "M136.543 91.54H63.406c-5.07 0-9.18 4.11-9.18 9.179v165.244c0 5.07 4.11 9.179 9.18 9.179h73.137c5.069 0 9.179-4.109 9.179-9.179V100.719c0-5.07-4.11-9.18-9.179-9.18z",
    opacity: 0.777
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M102.039 164.277v2.265h-3.735v-2.231c-3.03-.493-5.049-2.418-5.873-5.524l3.548-.995c.642 2.418 1.836 3.366 4.071 3.366 2.125 0 3.549-.948 3.549-2.664 0-1.224-.706-2.078-3.612-2.55-4.62-.85-6.978-2.694-6.978-6.001 0-2.974 2.124-5.138 5.295-5.72v-2.125h3.735v2.231c2.55.583 4.25 2.359 4.955 5.202l-3.548.952c-.582-2.206-1.56-3.09-3.43-3.09-2.078 0-3.272.948-3.272 2.55 0 1.254 1.011 1.836 3.918 2.418 4.556.948 6.668 2.754 6.668 6.15 0 2.894-2.078 5.065-5.291 5.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E75A2B",
    d: "M137.449 85.697c7.743 0 14.021 6.276 14.024 14.02v167.249c0 7.745-6.279 14.024-14.024 14.024H62.497c-7.745 0-14.023-6.279-14.023-14.024V99.72c0-7.745 6.278-14.023 14.024-14.023h74.951zm-13.157 10.662c-1.03 1.925-3.035 3.127-5.219 3.128H80.894c-2.183-.006-4.187-1.206-5.223-3.128l-2.583-4.802h-9.681c-5.063 0-9.17 4.1-9.18 9.162v165.244c0 5.07 4.11 9.179 9.18 9.179h73.137c5.069 0 9.179-4.109 9.179-9.179V100.736c0-5.07-4.11-9.18-9.179-9.18h-9.685l-2.567 4.803z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -94.178,
    x2: 200,
    y1: -96.433,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchNetwork);
export default __webpack_public_path__ + "static/media/switch-network.ad1670f9.svg";
export { ForwardRef as ReactComponent };